export const CONSENT_POLICY = {
  id: 'consent-policy',
  title: 'Consent Policy',
  version: 'v1.0-2026-05-17',
  effectiveDate: '17/05/2026',
  audience: 'all',
  content: `CONSENT POLICY — RESERVO

Status: DRAFT — pending solicitor review

1. PURPOSE

This policy sets out how Reservo collects, records, manages, and where required, re-collects consent from users of the Reservo platform under the Privacy Act 1988 (Cth), the Australian Privacy Principles, and other applicable laws.

2. PRINCIPLES

2.1 Reservo's approach to consent is based on the following principles:
  (a) consent must be voluntary, informed, current, specific, and given by a person with capacity;
  (b) consent must be appropriately recorded and retrievable;
  (c) consent must be capable of being withdrawn;
  (d) consent must be re-collected when material terms change.

3. TYPES OF CONSENT COLLECTED

Reservo collects consents in the following categories:

3.1 Terms of Use — every user accepts the Terms of Use at registration.

3.2 Privacy Policy — every user is provided with the Privacy Policy at registration.

3.3 Rider Agreement — every Rider accepts the Rider Agreement at registration.

3.4 Driver Agreement — every Driver accepts the Driver Agreement at the completion of driver onboarding and before being authorised to accept bookings.

3.5 Marketing Communications — opt-in for promotional emails and SMS, separate from transactional and safety communications.

3.6 Background Checks (Drivers) — explicit consent for criminal-history, driving-history, Working With Children, and identity-verification checks at onboarding and at each annual re-check.

3.7 Sensitive Information (Riders) — explicit consent for collection of any sensitive personal information including accessibility requirements, health information used to inform accessibility, and emergency-contact details.

3.8 Location Data — explicit consent for GPS tracking during active trips.

3.9 Audio Recording — currently NOT collected. If introduced, separate explicit consent will be obtained from both Rider and Driver before any recording.

3.10 Photo Evidence — by submitting photos through the platform (lost item, damage claim, incident), the user consents to those photos being used to resolve the matter (see Rider Agreement and Driver Agreement).

3.11 Corporate Authorised User — accepted at first use of a corporate-account-issued account.

4. CONSENT MECHANICS

4.1 Consent is obtained through tick-box or affirmative-action mechanisms in the Reservo platform. Pre-ticked boxes are not used.

4.2 Each consent is recorded in the user's account with:
  (a) document identifier and version;
  (b) date and time of consent;
  (c) IP address (where reasonably available);
  (d) device identifier (where reasonably available).

4.3 Consent records are retained for 7 years from the date of consent or 7 years from account closure, whichever is later.

5. RE-COLLECTION

5.1 Consent is re-collected when:
  (a) the Terms of Use, Privacy Policy, Rider Agreement, or Driver Agreement is updated in a material way;
  (b) a Driver's annual re-check date arrives;
  (c) a new category of consent is introduced (e.g. audio recording);
  (d) a user requests it.

5.2 Material changes are notified to users at least 14 days before they take effect, with continued use of the platform after that date constituting acceptance.

6. WITHDRAWAL OF CONSENT

6.1 Users may withdraw consent for:
  (a) marketing communications at any time through the unsubscribe link or in-app settings;
  (b) location data — though this will prevent further bookings, since location is essential to the service;
  (c) other categories on request to admin@reservo.au.

6.2 Withdrawal of consent for service-essential categories may result in suspension of the account.

6.3 Withdrawal is effective from the date received and is recorded in the user's consent register.

7. CONSENT FROM MINORS

7.1 Account holders must be at least 18 years old. Consent cannot be given by minors.

7.2 Where a child travels as a passenger under an adult account holder's booking, the adult provides all required consents on the child's behalf.

8. CAPACITY

8.1 A consent given by a person who lacks capacity to understand its nature is not valid.

8.2 If Reservo becomes aware that a user lacks capacity, the account may be paused and the matter referred to the user's guardian or attorney where one is identified.

9. WITHDRAWAL FOR SPECIFIC DATA CATEGORIES

9.1 Reservo retains some categories of personal information after consent withdrawal where required by law, including:
  (a) trip and incident records (7 years);
  (b) tax records (5 to 7 years);
  (c) audit logs (7 years);
  (d) ongoing legal claims.

10. AUDIT

10.1 Reservo audits consent collection at least annually to verify:
  (a) all account holders have recorded consent for all required documents;
  (b) consents are not stale (re-collected on material changes);
  (c) withdrawal requests have been actioned.

11. CONTACT

David Williams, Privacy Officer
Email: admin@reservo.au
Phone: 0435 679 630

---
VERSION HISTORY
v1.0 — 17/05/2026 — Initial draft for solicitor review.

---
THIS DOCUMENT IS A DRAFT FOR PRE-LAUNCH REVIEW.`,
};